var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.questionnaires),function(questionnaire){return _c('li',{key:questionnaire.id},[_c('router-link',{attrs:{"to":'/outcome/'+ questionnaire.id}},[_vm._v("\n\t\t\t"+_vm._s(questionnaire.display_name ? questionnaire.display_name : questionnaire.title)+"\n\t\t")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }